// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container[data-v-328c9910]{max-width:1185px}}.w-page-login[data-v-328c9910],.w-page-password_reset_confirmation[data-v-328c9910],.w-page-register[data-v-328c9910]{max-width:700px}.w-popup-dialog--mobile[data-v-328c9910]{display:flex;flex-direction:column}.w-popup-dialog--mobile .v-card__text[data-v-328c9910]{flex-grow:1;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
